import React, {useEffect, useState} from 'react';
import {Button, Form, Icon, Input, Label} from "semantic-ui-react";
import {Controller, useForm} from "react-hook-form";
import styles from './ClientsCRUD.form.module.scss'
import { IClient } from "./ClientsCRUD.types";
import { createClient, editClient } from "./ClientsCRUD.slice";
import { useAppDispatch, useAppSelector } from "../../../hooks/hooks";
//ToDo: ������� permittions, �������� ��������� �� Roles
import Permissions from "../../../components/Permissions/Permissions";
import { readClientPermissions } from "../../../store/cms/permissions/permissionsSlice";
import { emailRegex } from "../../../helpers/email.helper";

interface INewClientFormProps {
    closeForm: () => void
    editedClient: IClient | null
}

const NewClientForm: React.FC<INewClientFormProps> = ({closeForm, editedClient}) => {
    const dispatch = useAppDispatch()
    const { control, handleSubmit, formState: { errors }, getValues, setValue} = useForm();
    const {permissions, tourTypes} = useAppSelector(state => state.permissions)
    //const [selectedPermissions, setSelectedPermissions] = useState<string[]>([]);

    const setDefaultFormValue = () => {
        if (editedClient) {
            setValue("name", editedClient.name)
            setValue("email", editedClient.email)
            setValue("description", editedClient.description)
            setValue("domains", editedClient.domains)
            //setSelectedPermissions(editedClient.permissions)
        //    if (editedClient.id) {
        //        readExistingClientPermission(editedClient.id)
        //    }
        }
    }

    useEffect(() => {
        setDefaultFormValue()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editedClient]);

    const onCreateClient = () => {
        const payload: IClient = {
            name: getValues("name"),
            email: getValues("email"),
            isActive: true,
            description: getValues("description"),
            domains: getValues("domains"),
            users: 0,
            listeners: 0,
            //permissions: selectedPermissions
        }
        dispatch(createClient(payload))
        closeForm()
    }

    const onUpdateClient = () => {
        const payload: IClient = {
            id: editedClient!.id,
            name: getValues("name"),
            email: getValues("email"),
            isActive: true,
            description: getValues("description"),
            domains: getValues("domains"),
            users: 0,
            listeners: 0,
            //permissions: selectedPermissions
        }
        dispatch(editClient(payload))
        closeForm()
    }

    const selectPermission = (permission: string) => {
    //    const isExistPermission = selectedPermissions.find(item => item === permission)
    //    if (isExistPermission) {
    //        return setSelectedPermissions(selectedPermissions.filter(item => item !== permission))
    //    } else {
    //        setSelectedPermissions([...selectedPermissions, permission])
    //    }
    }

    //const readExistingClientPermission = (id: number) => {
    //    dispatch(readClientPermissions(id)).then(action => { setSelectedPermissions(action.payload?.codes); });
    //}

    return (
        <div className="form-overlay-general">
            <Form
                onSubmit={editedClient ? handleSubmit(onUpdateClient) : handleSubmit(onCreateClient)}
                className={styles.form}
            >
                <Icon
                    onClick={closeForm}
                    color="red"
                    name="close"
                    size="large"
                    style={{float: "right", cursor: "pointer"}}
                />
                <div className={styles.formRow}>
                    <Form.Field className={styles.formField}>
                        <Label>Name</Label>
                        <Controller
                            name="name"
                            control={control}
                            rules={{
                                required: true,
                            }}
                            render={({ field }) => (
                                <div className={styles.inputInner}>
                                    <Input placeholder={"Enter name"} {...field} />
                                </div>
                            )}
                        />
                        {errors.name && errors.name.type === 'required' &&
                            <div className={'darts-users-form-error-wrap'}>
                                <div><i className="warning sign red icon"></i></div>
                                <p className='darts-users-form-error'>The name field is required</p>
                            </div>}
                    </Form.Field>
                    <Form.Field className={styles.formField}>
                        <Label>Email</Label>
                        <Controller
                            name="email"
                            control={control}
                            rules={{
                                required: true,
                                pattern: emailRegex,
                            }}
                            render={({ field }) => (
                                <div className={styles.inputInner}>
                                    <Input placeholder={"Enter email"} {...field} />
                                </div>
                            )}
                        />
                        {errors.email && errors.email.type === 'required' &&
                            <div className={'darts-users-form-error-wrap'}>
                                <div><i className="warning sign red icon"></i></div>
                                <p className='darts-users-form-error'>The email field is required</p>
                            </div>}
                        {errors.email && errors.email.type === 'pattern' &&
                            <div className={'darts-users-form-error-wrap'}>
                                <div><i className="warning sign red icon"></i></div>
                                <p className='darts-users-form-error'>Email should be like example@xxx.xx</p>
                            </div>
                        }
                    </Form.Field>
                </div>
                <Form.Field>
                    <Label>Description</Label>
                    <Controller
                        name="description"
                        control={control}
                        rules={{
                            required: true,
                        }}
                        render={({ field }) => (
                            <div className={styles.inputInner}>
                                <Input placeholder={"Enter description"} {...field} />
                            </div>
                        )}
                    />
                    {errors.description && errors.description.type === 'required' &&
                        <div className={'darts-users-form-error-wrap'}>
                            <div><i className="warning sign red icon"></i></div>
                            <p className='darts-users-form-error'>The description field is required</p>
                        </div>
                    }
                </Form.Field>
                <Form.Field>
                    <Label>Domain</Label>
                    <Controller
                        name="domains"
                        control={control}
                        rules={{
                            required: true,
                        }}
                        render={({ field }) => (
                            <div className={styles.inputInner}>
                                <Input placeholder={"Enter domain"} {...field} />
                            </div>
                        )}
                    />
                    {errors.domains && errors.domains.type === 'required' &&
                        <div className={'darts-users-form-error-wrap'}>
                            <div><i className="warning sign red icon"></i></div>
                            <p className='darts-users-form-error'>The domain field is required</p>
                        </div>
                    }
                </Form.Field>
                {/*<Permissions*/}
                {/*    title={"Permissions"}*/}
                {/*    permissions={permissions}*/}
                {/*    selectPermission={selectPermission}*/}
                {/*/>*/}
                {/*<Permissions*/}
                {/*    title={"Tournament Types"}*/}
                {/*/>*/}
                    {/*selectPermission={selectPermission}*/}
                    {/*permissions={tourTypes}*/}
                <Button id="save_game" color="green" type="submit">
                    {editedClient ? "Update" : "Create"}
                </Button>
            </Form>
        </div>
    );
};

export default NewClientForm;
